import {IComponentOptions} from "angular";

export const ApplicationStatusComponent: IComponentOptions = {
    bindings: {
        application: "<",
        statusEnum: "<"
    },
    template: require("./application-status.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/status/application-status.component.ts